import moment from "moment";

const fieldEvent = (name, fieldId) => `${name} ::: ${fieldId}`;

const fieldIdRepeatEvent = (name, fieldId, repeatDataId) => {
	let eventData = fieldEvent(name, fieldId);

	if(repeatDataId !== null) {
		eventData += ` ::: ${repeatDataId || "undefined"}`;
	}
	return eventData;
};

export const EVENT_NEW_REPORTING_ENTITY = "EVENT_NEW_REPORTING_ENTITY";
export const EVENT_RESET_REPORTING_ENTITY = "EVENT_RESET_REPORTING_ENTITY";
export const EVENT_UPDATE_REPORTING_ENTITY_SELECTOR = "EVENT_UPDATE_REPORTING_ENTITY_SELECTOR";
export const EVENT_REQUEST_REPORTING_ENTITY = "EVENT_REQUEST_REPORTING_ENTITY";
export const EVENT_NEW_FORM = "EVENT_NEW_FORM";
export const EVENT_HOTKEY_LOCK = "EVENT_HOTKEY_LOCK";
export const EVENT_PROCESS_UI_RULES = "EVENT_PROCESS_UI_RULES";
export const EVENT_PROCESS_FILTER_RULES = "EVENT_PROCESS_FILTER_RULES";
export const EVENT_TRIGGER_FILTER_RULES = "EVENT_TRIGGER_FILTER_RULES";
export const EVENT_TRIGGER_RULE = (fieldId) => fieldEvent("EVENT_TRIGGER_RULE", fieldId);
export const EVENT_PROCESS_VALIDATIONS = "EVENT_PROCESS_VALIDATIONS";
export const EVENT_PAGE_LOADED = "EVENT_PAGE_LOADED";
export const EVENT_SET_FORM_DIRTY = "EVENT_SET_FORM_DIRTY";
export const ACTION_EXPAND_DETAILS = "ACTION_EXPAND_DETAILS";
export const ACTION_COLLAPSE_DETAILS = "ACTION_COLLAPSE_DETAILS";
export const ACTION_EXPAND_INVOICES = "ACTION_EXPAND_INVOICES";
export const ACTION_COLLAPSE_INVOICES = "ACTION_COLLAPSE_INVOICES";

export const EVENT_FILTER_PRIMARYDATE = "EVENT_FILTER_PRIMARYDATE";

export const EVENT_SET_FEATURE_DATA = (type) => `EVENT_SET_FEATURE_DATA ::: ${type}`;
export const EVENT_SET_VALUE = (fieldId) => fieldEvent("EVENT_SET_VALUE", fieldId);
export const EVENT_SET_DEFAULT_VALUE = (fieldId) => fieldEvent("EVENT_SET_DEFAULT_VALUE", fieldId);
export const EVENT_CLEAR_VALUE = (fieldId, repeatDataId) => fieldIdRepeatEvent("EVENT_CLEAR_VALUE", fieldId, repeatDataId);
export const EVENT_FILTER_BY_DETAILS = (fieldId) => fieldEvent("EVENT_FILTER_BY_DETAILS", fieldId);
export const EVENT_UNCLEAR_VALUE = (fieldId, repeatDataId) => fieldIdRepeatEvent("EVENT_UNCLEAR_VALUE", fieldId, repeatDataId);
export const EVENT_CLEAR_ROW = (repeatDataId) => fieldEvent("EVENT_CLEAR_ROW", repeatDataId);
export const EVENT_VALUE_CLEARED = (fieldId) => fieldEvent("EVENT_VALUE_CLEARED", fieldId);
export const EVENT_FILTER_CURRENT_OPTIONS = (fieldId, repeatDataId) => fieldIdRepeatEvent("EVENT_FILTER_CURRENT_OPTIONS", fieldId, repeatDataId);
export const EVENT_FILTER_ALL_OPTIONS = (fieldId, repeatDataId) => fieldIdRepeatEvent("EVENT_FILTER_ALL_OPTIONS", fieldId, repeatDataId);
export const EVENT_REMOVE_OPTIONS = (fieldId) => fieldEvent("EVENT_REMOVE_OPTIONS", fieldId);
export const EVENT_LOAD_OPTIONS = (fieldId) => fieldEvent("EVENT_LOAD_OPTIONS", fieldId);
export const ENTITY_SELECTOR_REFERENCE = "ENTITY_SELECTOR";

export const EVENT_VALUE_CHANGED = (fieldId, repeatDataId) => fieldIdRepeatEvent("EVENT_VALUE_CHANGED", fieldId, repeatDataId);

export const EVENT_FIELD_DISABLE = (fieldId) => fieldEvent("EVENT_FIELD_DISABLE", fieldId);
export const EVENT_FIELD_ENABLE = (fieldId) => fieldEvent("EVENT_FIELD_ENABLE", fieldId);
export const EVENT_SECTION_FIELD_VISIBILTY_CHANGE = (sectionId) => fieldEvent("EVENT_SECTION_FIELD_VISIBILITY_CHANGE", sectionId);
export const EVENT_TIMEZONE_SET = (fieldId) => fieldEvent("EVENT_TIMEZONE_SET", fieldId);

export const EVENT_FIELD_DIRTY = "EVENT_FIELD_DIRTY";
export const EVENT_SET_FORM_PRISTINE = "EVENT_SET_FORM_PRISTINE";
export const EVENT_DETAIL_DIRTY = "EVENT_DETAIL_DIRTY";
export const EVENT_DETAIL_TOGGLE = "EVENT_DETAIL_TOGGLE";
export const EVENT_REPORT_LOCKED = "EVENT_REPORT_LOCKED";
export const EVENT_REPORT_UNLOCKED = "EVENT_REPORT_UNLOCKED";
export const EVENT_REPORT_STATUS_CHANGE = "EVENT_REPORT_STATUS_CHANGE";
export const EVENT_REPORT_SAVED = "EVENT_REPORT_SAVED";
export const EVENT_DETAILS_SUPPRESSION_TOGGLED = "EVENT_DETAILS_SUPPRESSION_TOGGLED";
export const EVENT_TRIGGER_REPORT_SAVE = "EVENT_TRIGGER_REPORT_SAVE";
export const EVENT_EXPAND_MULTI_ENTRY_LIST = "EVENT_EXPAND_MULTI_ENTRY_LIST";
export const EVENT_REVERT_VALUES = "EVENT_REVERT_VALUES";
export const EVENT_PROCESS_RULES_SETTLED = "EVENT_PROCESS_RULES_SETTLED";

export const EVENT_GET_VALUE = (fieldId) => fieldEvent("EVENT_GET_VALUE", fieldId);
export const EVENT_SEND_VALUE = (fieldId) => fieldEvent("EVENT_SEND_VALUE", fieldId);

export const EVENT_ENABLE_SUCCESSOR_LOCK = (fieldId, repeatId) => fieldIdRepeatEvent("EVENT_ENABLE_SUCCESSOR_LOCK", fieldId, repeatId);
export const EVENT_DISABLE_SUCCESSOR_LOCK = (fieldId, repeatId) => fieldIdRepeatEvent("EVENT_DISABLE_SUCCESSOR_LOCK", fieldId, repeatId);
export const EVENT_HANDLE_SUCCESSOR_LOCK = (fieldId) => fieldEvent("EVENT_HANDLE_SUCCESSOR_LOCK", fieldId);

export const EVENT_LOGOUT = "EVENT_LOGOUT";

export const PROXY_FIELDS = {
	DATETIME: "PROXY_DATETIME_FIELD",
	ENTITY: "PROXY_ENTITY_FIELD"
};

export const openIdCallbackSuffix = "/auth/callback";
export const openIdSilentRenewPath = "/auth/renew";
export const maxAuthClockSkewSeconds = 5 * 60;

//Misc.

export const ENTITY_TYPES = {
	VESSEL: { Code: "VESSEL", Name: "Vessel", PluralName: "Vessels", Icon: "zmdi-boat" },
	DEALER: { Code: "DEALER", Name: "Dealer", PluralName: "Dealers", Icon: "zmdi-store" },
	FISHERMAN: { Code: "FISHERMAN", Name: "Fisherman", PluralName: "Fishermen", Icon: "zmdi-account-o" },
	LICENSE: { Code: "LICENSE", Name: "License", PluralName: "Licenses", Icon: "zmdi-card" },
	GROUP: { Code: "GROUP", Name: "Group", PluralName: "Groups", Icon: "zmdi-card" },
	CAPTAIN: { Code: "CAPTAIN", Name: "Captain", PluralName: "Captains", Icon: "zmdi-card" },
	BUSINESS: { Code: "BUSINESS", Name: "Business", PluralName: "Businesses", Icon: "zmdi-store" },
	DEFAULT: { Icon: "zmdi-account-o" }
};

export const RELATIONSHIP_TYPES = {
	Self: "SELF"
};

export const LOADING_MESSAGES = [
	"Battening the hatches",
	"Setting the sails",
	"Setting out the lines",
	"Releasing the Kraken",
	"Outrunning the Kraken",
	"Assembling all hands on deck",
	"Casting off",
	"Feeding the Kraken"
];

export const NOMENCLATURE = {
	PositiveReport: "FORM.REPORTING.POSITIVE",
	NegativeReport: "FORM.REPORTING.NEGATIVE",
	ReportFooter: "FORM.REPORTING.FOOTER",
	PrimaryEntity: "FORM.PRIMARY.ENTITY",
	PrimaryDate: "FORM.PRIMARY.DATE",
	SupportEmail: "FORM.SUPPORT.EMAIL",
	SupportNumber: "FORM.SUPPORT.PHONE",
	Season: "FORM.SEASON",
	LogoUrl: "FORM.LOGO",
	SupportMarkdown: "FORM.SUPPORT.MARKDOWN",
	FormUseAcceptance: "FORM.ACCEPTANCE"
};

export const REPORT_SCOPES = {
	report: "REPORT",
	detail: "DETAIL",
	details: "DETAILS",
	reportAndDetails: "REPORTANDDETAILS",
	metadata: "METADATA"
};

export const UNITS = {
	feet: { 
		singular: "foot",
		plural: "feet",
		abbreviation: "ft",
		decoration: "'",
		per: {
			meter: 3.28084
		}
	},
	meter: {
		singular: "meter",
		plural: "meters",
		abbreviation: "m",
		per: {
			foot: 0.3048
		}
	}
};

export const FIELD_TEMPLATES = {
	Coordinate: "Coordinate",
	Date: "Date",
	DateTime: "DateTime",
	Time: "Time",
	YearMonth: "YearMonth",
	Location: "Location",
	Number: "Number",
	EntitySelector: "EntitySelector",
	EntityContactSelector: "EntityContactSelector",
	Selection: "Selection",
	Tags: "MultiSelect",
	TextArea: "TextArea",
	Text: "Text",
	StringMulti: "StringMulti",
	Boolean: "Boolean",
	Markdown: "Markdown",
	SingleFile: "SingleFile",
	ImageFile: "ImageFile"
};

export const FEATURE_TYPES = {
	filter: "Filter",
	map: "Map",
	mapPoint: "MapPoint",
	boundlessMapPoint: "MapWithoutBoundary",
	propagate: "PropagateValue",
	dateRangeDefaultYearMonth: "DateRangeDefaultYearMonth",
	webCardSwipe: "WebCardSwipe",
	tokenScanToReport: "TokenScanToReport",
	advancedCompliance: "AdvancedCompliance"
};

export const FIELD_KEYS = {
	quantity: "TRIP.DETAILS.SPECIES.QUANTITY.COUNT",
	price: "TRIP.DETAILS.PRICE.VALUE",
	latitude: "TRIP.AREAS.LATITUDE.SINGLE",
	longitude: "TRIP.AREAS.LONGITUDE.SINGLE",
	location: "TRIP.AREAS.SUBAREAS.SINGLE",
	tripType: "TRIP.TYPES.SINGLE",
	tagBegin: "HARVEST.DETAILS.TAG.BEGIN",
	tagEnd: "HARVEST.DETAILS.TAG.END"
};

export const FIELD_TYPES = {
	entity: "ENTITY",
	entityContact: "ENTITYCONTACT"
};

export const TIME_ZONES = [
	{
		name: "Eastern Time",
		code: (date) => moment(date).isDST() ? "EDT" : "EST",
		ianaCode: "America/New_York",
		cities: ["New York", "Boston", "Miami"]
	},
	{
		name: "Central Time",
		code: (date) => moment(date).isDST() ? "CDT" : "CST",
		ianaCode: "America/Chicago",
		cities: ["Chicago", "Dallas", "New Orleans"]
	},
	{
		name: "Mountain Time",
		code: (date) => moment(date).isDST() ? "MDT" : "MST",
		ianaCode: "America/Denver",
		cities: ["Denver", "Salt Lake City", "Albuquerque"]
	},
	{
		name: "Pacific Time",
		code: (date) => moment(date).isDST() ? "PDT" : "PST",
		ianaCode: "America/Los_Angeles",
		cities: ["Los Angeles", "San Francisco", "Seattle"]
	},
	{
		name: "Atlantic Time",
		code: date => moment(date).isDST() ? "ADT" : "AST",
		ianaCode: "America/St_Thomas",
		cities: ["St. Thomas", "San Juan"]
	}
];

export const FORM_TIMEZONE_TYPES = {
	ByEntity: "BYENTITY",
	ByForm: "BYFORM",
	ByUser: "BYUSER"
};

export const TIME_DISPLAY_OPTIONS = {
	TWENTY_FOUR_HOUR: "24h",
	TWELVE_HOUR: "12h"
};

export const PIVOT_TYPES = {
	All: "All",
	Repeat: "Repeat",
	RecentlyUsed: "RecentlyUsed"
};

export const USAGE_DEFAULT_MODES = {
	MostRecentlyUsed: "MostRecentlyUsed",
	MostOftenUsed: "MostOftenUsed"
};

export const IDENTIFIER_TYPES = {
	"ACCSP:ID": { code: "ACCSP:ID", name: "ACCSP Unique Id" },
	"GARFO:ACCSP:ID": { code: "GARFO:ACCSP:ID", name: "GARFO ACCSP Unique Id" },
	DL: { code: "DL", name: "Driver's License No." },
	CGN: { code: "CGN", name: "Coast Guard No." },
	"STATE:REGISTRATION": { code: "STATE:REGISTRATION", name: "State Registration No." },
	PLATE: { code: "PLATE", name: "Plate Number" },
	TOKEN: { code: "TOKEN", name: "Token" },
	PREFIX: { code: "PREFIX", name: "Prefix" },
	GARFO: { code: "GARFO", name: "GARFO Permit Number", isFederal: true },
	SERO: { code: "SERO", name: "SERO Permit Number", isFederal: true },
	"SERO:GULF": { code: "SERO:GULF", name: "SERO Gulf Permit Number" },
	VESSEL: { code: "VESSEL", name: "Vessel" },
	CFID: { code: "CFID", name: "Commercial Fisheries ID" },
	"ACCSP:VESSEL:ID": { code: "ACCSP:VESSEL:ID", name: "ACCSP Permit Id" },
	"LOCALE": { code: "LOCALE", name: "Locale" }
};

export const CLASSIFICATION_TYPES = {
	TUNA: "TUNA",
	SHARK: "SHARK",
	SWORDFISH: "SWORDFISH"
};

export const NAME_SUFFIX_LIST = [
	{ key: "Jr.", display: "Jr.", show: true },
	{ key: "Sr.", display: "Sr.", show: true },
	{ key: "II", display: "II", show: true },
	{ key: "III", display: "III", show: true },
	{ key: "IV", display: "IV", show: true },
	{ key: "V", display: "V", show: true },
	{ key: "VI", display: "VI", show: true },
	{ key: "JR", display: "Jr." },
	{ key: "JR.", display: "Jr." },
	{ key: "L", display: "" },
	{ key: "I", display: "" },
	{ key: "SR", display: "Sr." },
	{ key: "J", display: "Jr." }
];

export const NAME_TITLE_LIST = [
	{ key: "Mr.", display: "Mr.", value: "Mr", show: true },
	{ key: "Ms.", display: "Ms.", value: "Ms", show: true },
	{ key: "Mrs.", display: "Mrs.", value: "Mrs", show: true },
	{ key: "Capt.", display: "Capt.", value: "Capt", show: true },
	{ key: "Dr.", display: "Dr.", value: "Dr", show: true }
];

export const IS_NOT_AVAILABLE_OPTIONS = {
	always: "Always",
	never: "Never",
	supported: "Supported"
};

export const IS_NOT_AVAILABLE_VALUE = "$[NA]$";


export const SELECTORS = {
	TabbableElements: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
};

export const READ_ONLY_MODES = {
	afterCreate: "AfterCreate",
	afterFirstSet: "AfterFirstSet",
	system: "System",
	always: "Always"
};

export const REPORT_STATES = {
	submitted: {
		code: "SUBMITTED",
		display: "Completed"
	},
	deleted: {
		code: "DELETED",
		display: "Deleted"
	},
	pending: {
		code: "PENDING",
		display: "Pending"
	},
	declared: {
		code: "DECLARED",
		display: "Declared"
	}
};

export const SEVERITY_LEVELS = {
	CRITICAL: {
		order: 0,
		icon: "zmdi-alert-polygon",
		cssClass: "critical"
	},
	ERROR: {
		order: 1,
		icon: "zmdi-alert-octagon",
		cssClass: "error"
	},
	WARNING: {
		order: 2,
		icon: "zmdi-alert-triangle",
		cssClass: "warning"
	},
	INFO: {
		order: 3,
		icon: "zmdi-info",
		cssClass: "info"
	},
	UNKNOWN: {
		order: 4,
		icon: undefined,
		cssClass: "unknown"
	}
};

export const ENTITY_RELATIONSHIP_KINDS = {
	Forward: "HIERARCHY-FORWARD",
	Reverse: "HIERARCHY-REVERSE"
};

export const AGREEMENT_REQUIREMENT_TYPES = {
	AFFIRM: "AFFIRM",
	SIGN: "SIGN",
	SHOW: "SHOW"
};

export const AGREEMENT_INTERACTION_TYPES = {
	ACCEPT: "ACCEPT",
	SIGN: "SIGN",
	ACCEPT_ALWAYS: "ACCEPT_ALWAYS",
	REJECT: "REJECT",
	DISMISS: "DISMISS",
	READ: "READ"
};

export const VALID_INTERACTIONS_FOR_REQUIREMENT = {
	[AGREEMENT_REQUIREMENT_TYPES.AFFIRM]: {
		[AGREEMENT_INTERACTION_TYPES.ACCEPT]: true,
		[AGREEMENT_INTERACTION_TYPES.ACCEPT_ALWAYS]: true,
		[AGREEMENT_INTERACTION_TYPES.REJECT]: false																							
	},
	[AGREEMENT_REQUIREMENT_TYPES.SHOW]: {
		[AGREEMENT_INTERACTION_TYPES.READ]: true,
		[AGREEMENT_INTERACTION_TYPES.DISMISS]: false
	},
	[AGREEMENT_REQUIREMENT_TYPES.SIGN]: {
		[AGREEMENT_INTERACTION_TYPES.SIGN]: true,
		[AGREEMENT_INTERACTION_TYPES.REJECT]: false																							
	}
};
